import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { registerPageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Registration";
import pageManagerConfiguration from "./Ui/PageManagerConfiguration";

export async function registerModuleContactsAsync(configuration: Configuration)
{
    registerPageManagerConfiguration(configuration, pageManagerConfiguration);
}